import React, { useState } from 'react';
import { Card, Row, Col, Input, Button, Spin, Comment, Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { SendOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';

import LoggedLayout from '../../components/Layouts/LoggedLayout';
import _s from './index.less';
import { Plans } from '../../components/FloorPlans/List';

const AssistantPage = () => {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [plans, setPlans] = useState([]);
  const [viewMode, setViewMode] = useState(0);

  const handleInputChange = e => {
    setInputValue(e.target.value);
  };

  const handleSendRequest = async () => {
    setLoading(true);
    messages.push({ role: 'user', content: inputValue });

    try {
      const response = await axios({
        method: 'post',
        url: '/api/assistant-search-plan',
        data: {
          messages: messages
        }
      });

      setPlans(response.data.plans);
      setMessages(response.data.messages);
      setInputValue('');

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getActions = item => {
    const actions = [
      <Link className={_s.action} key={`link-${item._id}`} to={`/plan/${item._id}`}>
        View
      </Link>
    ];
    return actions;
  };

  return (
    <LoggedLayout>
      <Row justify="center" align="middle" style={{ width: '100%', marginTop: '2em' }}>
        <Col xs={24} sm={24} md={18}>
          <Card style={{ textAlign: 'center' }}>
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <img height="250" src="/public/images/bird.png" alt="" />
              </Col>
              <Col xs={24} md={16}>
                <div className={_s.titleBird}>
                  <div className={_s.text}>{`Hi, I'll help you find a house.`}</div>
                  <div className={_s.text}>
                    {`Please write down what you need a house for and what you want. For example: "I want a small house for one person"`}
                  </div>
                </div>
              </Col>
            </Row>
            <div style={{ marginTop: '2em' }}>
              {messages &&
                messages.length > 0 &&
                messages.map((message, key) => (
                  <Comment
                    className={_s.message}
                    key={`message-${key}`}
                    style={{ backgroundColor: key % 2 ? '#fafafa' : 'white' }}
                    author={message.role === 'assistant' ? 'Assistant' : 'User'}
                    avatar={
                      message.role === 'assistant' ? (
                        <Avatar src="/public/images/favicon.ico" alt="Assistant" />
                      ) : (
                        <Avatar icon={<UserOutlined />} />
                      )
                    }
                    content={<p className={_s.text}>{message.text || message.content}</p>}
                  />
                ))}
            </div>
            {!loading && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                  value={inputValue}
                  onChange={handleInputChange}
                  style={{ width: '100%', marginRight: 8 }}
                  placeholder="Enter your text"
                />
                <Button type="primary" onClick={handleSendRequest} icon={<SendOutlined />}>
                  Send
                </Button>
              </div>
            )}
            {loading ? (
              <Spin style={{ marginTop: 16 }} />
            ) : (
              <div style={{ marginTop: '2em' }}>
                {plans.length > 0 && (
                  <Plans
                    items={plans}
                    viewMode={viewMode}
                    getActions={getActions}
                    setViewMode={setViewMode}
                  />
                )}
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </LoggedLayout>
  );
};

export default AssistantPage;
